<div class="mat-elevation-z8">
   <mat-card>
     <mat-card-content>
         <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="custom-tabs"
         [selectedIndex]="activeTabIndex()"
         (selectedTabChange)="activeTabIndex.set($event.index)" [dynamicHeight]="true">
         <mat-tab label="Daily Dosing" class="custom-tabs"> 
            <app-daily-dosing></app-daily-dosing>
         </mat-tab>
         <mat-tab label="Salisbury Dosing">
            <app-salisbury-dosing></app-salisbury-dosing>
         </mat-tab>
         </mat-tab-group>
      </mat-card-content>
   </mat-card>
</div>